import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { workflowStages } from "../content/portfolio";
import type { PillarId, PillarSelections } from "../types";

const initialPillarSelections: PillarSelections = {
  reliability: null,
  product: null,
  leverage: null,
};

interface PortfolioState {
  hasInteracted: boolean;
  selectedAiSection: string | null;
  selectedWorkflowStage: string;
  selectedPillarPrinciples: PillarSelections;
  visited: string[];
  setInteracted: () => void;
  setAiSection: (section: string | null) => void;
  setWorkflowStage: (stage: string) => void;
  setPillarPrinciple: (pillar: PillarId, principle: string | null) => void;
  markVisited: (route: string) => void;
}

export const usePortfolioStore = create<PortfolioState>()(
  persist(
    (set) => ({
      hasInteracted: false,
      selectedAiSection: null,
      selectedWorkflowStage: workflowStages[0].id,
      selectedPillarPrinciples: initialPillarSelections,
      visited: [],
      setInteracted: () => set({ hasInteracted: true }),
      setAiSection: (selectedAiSection) => set({ selectedAiSection }),
      setWorkflowStage: (selectedWorkflowStage) => set({ selectedWorkflowStage }),
      setPillarPrinciple: (pillar, principle) =>
        set((state) => ({
          selectedPillarPrinciples: {
            ...initialPillarSelections,
            ...state.selectedPillarPrinciples,
            [pillar]: principle,
          },
        })),
      markVisited: (route) =>
        set((state) => ({
          visited: state.visited.includes(route)
            ? state.visited
            : [...state.visited, route],
        })),
    }),
    {
      name: "curiosity-engine-state",
      version: 1,
      storage: createJSONStorage(() => localStorage),
      partialize: ({
        hasInteracted,
        selectedAiSection,
        selectedWorkflowStage,
        selectedPillarPrinciples,
        visited,
      }) => ({
        hasInteracted,
        selectedAiSection,
        selectedWorkflowStage,
        selectedPillarPrinciples,
        visited,
      }),
    },
  ),
);
